import { useEffect, useState } from 'react';

import translateService from './translate.sevice';

export const useTranslateList = () => {
  const [data, setData] = useState<Array<string>>([]);

  useEffect(() => {
    const fetchData = async () => {
      const result: any = await translateService.langList();
      const list = result.filter((c: string) => c !== 'en-US');
      setData([''].concat(list));
    };
    fetchData();
  }, []);

  return data;
};

export const useTranslateListAll = () => {
  const [data, setData] = useState<Array<any>>([]);

  useEffect(() => {
    const fetchData = async () => {
      const result: any = await translateService.langList();
      const list = result.map((c: any) => {
        return { id: c, name: c };
      });
      setData(list);
    };
    fetchData();
  }, []);

  return data;
};
